import { Address } from '../types';

export const mapValidateAddressRequest = (data: any): Address => ({
  city: data.city,
  state: data.state,
  street: data.street,
  unit: data.unit,
  zip: data.zip,
});
